// Helper function to convert data (model) to digitalData for tracking event

/**
 * Get tracking compare trim id list
 * @param {Array<Object>} trimDetails - Array of trim details (key modelId, colorCode)
 * @param {String} prefix - Prefix for the tracking value. One of 'q', 'i', 'c', 'hmc'
 * @returns {String}
 */
const getDefaultComparisonModel = (selectedTrims, prefix) => {
  const value = selectedTrims
    .map((trim) => `${prefix}:${trim.modelId}-${trim.colorCode}`)
    .join('|')
    .toLowerCase();

  return {
    'default_comp_model': value,
  };
};

/**
 * Get tracking default compare trim id list
 * @param {Array<Object>} trimDetails - Array of trim details (key modelId, colorCode)
 * @param {String} prefix - Prefix for the tracking value. One of 'q', 'i', 'c'
 * @returns {Object}
 */
const getComparisonModel = (trimDetails, prefix) => {
  const selectedTrims = trimDetails.map((trim) => ({
    modelId: trim.id,
    colorCode: trim.selectedColor?.mfgColorCode,
  }));

  const digitalDataCompare = {
    ...getDefaultComparisonModel(selectedTrims, prefix),
  };

  const numberOfTrims = 3;

  for (let index = 0; index < numberOfTrims; index++) {
    const trim = trimDetails[index];
    const comparisonKey = index === 0 ? 'comp' : `comp${index + 1}`;
    if (trim) {
      digitalDataCompare[`${comparisonKey}_year`] = String(trim.year);
      digitalDataCompare[`${comparisonKey}_model`] = trim.family;
      digitalDataCompare[`${comparisonKey}_trim`] = trim.name;
      digitalDataCompare[`${comparisonKey}_msrp`] = String(Number(trim.msrp.replace('$', '').replace(',', '')));
      digitalDataCompare[`${comparisonKey}_brand`] = 'honda powersports';
      digitalDataCompare[`${comparisonKey}_color`] = trim.selectedColor?.colorName;
      digitalDataCompare[`${comparisonKey}_tile_position`] = String(index + 1);
    } else {
      digitalDataCompare[`${comparisonKey}_year`] = '';
      digitalDataCompare[`${comparisonKey}_model`] = '';
      digitalDataCompare[`${comparisonKey}_trim`] = '';
      digitalDataCompare[`${comparisonKey}_msrp`] = '';
      digitalDataCompare[`${comparisonKey}_brand`] = '';
      digitalDataCompare[`${comparisonKey}_color`] = '';
      digitalDataCompare[`${comparisonKey}_tile_position`] = '';
    }
  }

  return digitalDataCompare;
};

export {
  getDefaultComparisonModel,
  getComparisonModel,
};